import {usePathname, useSearchParams} from '@/lib/router'
import {type MenuKey, menus} from '@/lib/constants'
import type {Contact} from '@/types'

type MenuItem = (typeof menus)[MenuKey]['items'][number]

type RouteContext = {
    activeMenu: MenuKey
    activeItem: MenuItem
    activeConversationWxid: string
    groups: Contact[]
    friends: Contact[]
}

export function useRouteContext(contacts: Contact[]): RouteContext {
    const pathname = usePathname()
    const searchParams = useSearchParams()

    const activeConversationWxid =
        searchParams.get('conversationWxid') || searchParams.get('wxid') || ''

    const rawSection = pathname.split('/')[1] || 'message'
    const activeMenu: MenuKey = menus[rawSection as MenuKey] ? (rawSection as MenuKey) : 'message'
    const activeItem: MenuItem =
        Object.values(menus)
            .flatMap((menu) => menu.items)
            .find((item) => item.path === pathname) || menus[activeMenu].items[0]

    const groups = contacts.filter((contact) => contact.wxid.includes('@chatroom'))
    const friends = contacts.filter((contact) => !contact.wxid.includes('@chatroom'))

    return {activeMenu, activeItem, activeConversationWxid, groups, friends}
}
